export const RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS =
	'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';
